import { logger } from "react-native-logs"; // Importa el objeto logger correctamente
import { APP_ENABLE_CONSOLE_LOGGING } from "../interceptors/axiosConfig";
// Definir niveles de log como una constante reutilizable
var LOG_LEVELS = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
};
// Crear instancia de logger usando `createLogger()`
var loggerInstance = logger.createLogger({
    levels: LOG_LEVELS,
    severity: "trace",
    dateFormat: "time",
    printLevel: true,
    printDate: false,
    enabled: APP_ENABLE_CONSOLE_LOGGING === "true",
});
// Exportar la instancia de logger con el nombre `logger`
export { loggerInstance as logger };
